import React from "react";

// Reusable Card Component
const Card = ({ title, value, icon, borderColor, subText, onClick, style }) => {
  return (
    <div className="col-xl-3 col-md-6">
      <div
        className={`card border-left-${borderColor} shadow py-2`}
        style={{ height: "83%", cursor: onClick ? "pointer" : "default", ...style }}
        onClick={onClick}
        role={onClick ? "button" : undefined}
        tabIndex={onClick ? 0 : undefined}
        onKeyPress={(e) => {
          if (onClick && (e.key === "Enter" || e.key === " ")) {
            onClick();
          }
        }}
      >
        <div className="card-body">
          <div className="row no-gutters align-items-center h-100">
            <div className="col mr-2">
              <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                {title}
              </div>
              <div className="h3 mb-0 font-weight-bold text-gray-800">
                {value || 0}
              </div>
              {subText && <small className="text-muted">{subText}</small>}
            </div>
            <div className="col-auto">
              {React.cloneElement(icon, {
                size: 40,
                className: "text-gray-300",
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


export default Card;